import { AppConfigurationKey } from '../../../../model/enums/appConfigurationKey'
import { ObjectionsModel } from '../../../../pages/invoicesPage/invoicesPage.Model'
import { getAppConfigurationValue } from '../../../../redux'
import AxiosInstance from '../../../http-config'
import {
  ObjectionBulkUpdateRequest,
  ObjectionsModelRequest,
  ResolveObjectionsModel
} from './model/objections'

export const apiSaveObjection = async (
  objection: ObjectionsModelRequest
): Promise<ObjectionsModel> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Objections/CreateObjection`, objection).then(
    response => {
      if (response.data.length > 0) {
        return response.data
      }
    }
  )
}

export const apiPostResolveObjections = async (request: ResolveObjectionsModel): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)

  await AxiosInstance.post(`${apiSuffixUrl}/api/Objections/SendResolveObjections`, request).then(
    response => {
      if (response.data) {
        return response.data
      }
    }
  )
}

export const apiTerminateObjection = async (objectionId: number): Promise<any> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  let params = {}
  return await AxiosInstance.patch(
    `${apiSuffixUrl}/api/Objections/Terminate(${objectionId})`,
    params
  ).then(response => {
    if (response.data) {
      return response.data
    }
  })
}

export const apiBulkUpdateObjections = async (data: ObjectionBulkUpdateRequest): Promise<void> => {
  const apiSuffixUrl = getAppConfigurationValue(AppConfigurationKey.PrefixEnviromentArgentia)
  return await AxiosInstance.post(`${apiSuffixUrl}/api/Objections/BulkUpdate`, data)
}
